import NewsFeedSection from "./NewsFeedSection";

export default NewsFeedSection;
